var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.positionY && _vm.isNearestPlace)?_c('div',{staticClass:"question__date",style:({
    'top': _vm.positionY + 'px',
    'height': _vm.height + 'px',
    'border-color': _vm.tableQuestionPlace.color,
})}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }